<template>
  <div class="invoiceTitle">
    <van-form label-width="120px" :show-error="false" @submit="onSubmit">
      <van-notice-bar left-icon="warning-o" :text="$t.invoiceTitle.alert" />

      <van-field
        :label="$t.invoiceTitle.titleType"
        :value="$t.invoiceTitle.unit"
        disabled
      />

      <van-field
        v-model="form.CompanyTaxNumber"
        :label="$t.invoiceTitle.taxNumber"
        :placeholder="disabled ? '' : $t.meta.input"
        :disabled="disabled ? true : false"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.CompanyAddress"
        :label="$t.invoiceTitle.address"
        :placeholder="disabled ? '' : $t.meta.input"
        :disabled="disabled ? true : false"
      />

      <van-field
        v-model="form.CompanyPhone"
        :label="$t.invoiceTitle.phone"
        :placeholder="disabled ? '' : $t.meta.input"
        :disabled="disabled ? true : false"
      />

      <van-field
        v-model="form.BankName"
        :label="$t.invoiceTitle.bankName"
        :placeholder="disabled ? '' : $t.meta.input"
        :disabled="disabled ? true : false"
      />

      <van-field
        v-model="form.BankAccount"
        :label="$t.invoiceTitle.bankAccount"
        :placeholder="disabled ? '' : $t.meta.input"
        :disabled="disabled ? true : false"
      />

      <div style="margin: 16px" v-if="!disabled">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.save
        }}</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image, NoticeBar } from "vant";

Vue.use(Form).use(Field).use(Button).use(Icon).use(Image).use(NoticeBar);

export default {
  name: "invoiceTitle",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      form: {
        CITId: 0,
        TitleType: "1",
        CompanyTaxNumber: "",
        CompanyAddress: "",
        CompanyPhone: "",
        BankName: "",
        BankAccount: "",
      },
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      disabled: false,
    };
  },
  created() {
    this.loadCompanyInvoiceTitleInfo();
  },
  methods: {
    loadCompanyInvoiceTitleInfo() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          UserId: this.UserId,
        };
        this.$api.systemManagement
          .loadCompanyInvoiceTitleInfo(param)
          .then((res) => {
            this.form = res.data;
            if (this.form.CITId == 0) {
              this.disabled = false;
            } else {
              this.disabled = true;
            }
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      this.$api.systemManagement
        .addCompanyInvoiceTitle(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.loadCompanyInvoiceTitleInfo();
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.invoiceTitle {
  ::v-deep .number-label {
    line-height: 33px;
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  ::v-deep .van-radio__icon--disabled.van-radio__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }
  ::v-deep .van-radio__label--disabled.van-radio__label {
    color: #323233 !important;
    -webkit-text-fill-color: #323233 !important;
  }
  ::v-deep .van-checkbox__icon--disabled.van-checkbox__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }
  ::v-deep .van-checkbox__label--disabled.van-checkbox__label {
    color: #323233 !important;
    -webkit-text-fill-color: #323233 !important;
  }
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #323233 !important;
      -webkit-text-fill-color: #323233 !important;
    }
  }
}
</style>
